import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoContri = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_contri',
        name: 'Tipo Contribuyente',
        component: ViewTipoContri,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
